const getQueryString = params => {
  return Object.keys(params)
    .map(k => `${k}=${encodeURI(params[k])}`)
    .join('&');
};

export default getQueryString;
